<template>
  <div class="main-page">
    <section class="page-notification">
      <slot name="pre-header"></slot>
    </section>
    <section class="page-header" :class="{'has-sidebar': pageHasSidebar, 'has-notification': $props.hasNotification}" v-if="pageHasHeader">
      <div class="page-header-inner" :class="{'has-sidebar': pageHasSidebar}">
        <slot name="header"></slot>
      </div>
    </section>
    <section class="page-content" :class="{'has-sidebar': pageHasSidebar, 'has-header': pageHasHeader, 'full-width': $props.fullWidth}">
      <slot></slot>
    </section>
  </div>
</template>

<script>
import { customRouter } from '@/customRouter'

export default {
  name: 'page-layout',
  props: {
    hasNotification: Boolean,
    fullWidth: Boolean,
    hasHeader: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    pageHasSidebar () {
      return !!this.$parent.$slots.sidebar
    },
    pageHasHeader () {
      return !!this.$slots.header && this.$props.hasHeader
    },
    benefitsLinkVisible () {
      return customRouter.getCurrentRoute() !== 'benefiti'
    }
  }
}
</script>

<style scoped lang="scss">
.page-header {
  position: relative;
  padding: 1.8rem 0 1.8rem 0;
  background-image: linear-gradient(to right, #ed1a3b, #cf1432 9%, #ed1a3b 25%, #f58220);

  @media (map_get($breakpoints, sm)) {
    padding-top: 40px;
  }

  &.has-sidebar {
    padding: 6rem 0 1.6rem 0;

    @media (map_get($breakpoints, sm)) {
      padding-top: 90px;
    }

    @media (map_get($breakpoints, md)) {
      padding-top: 40px;
    }
  }

  .page-header-inner {
    margin: 0 auto;
    padding: 0 2rem;

    @media (map_get($breakpoints, sm)) {
      //max-width: 700px;
    }

    @media (map_get($breakpoints, md)) {
      max-width: 960px;
    }

    @media (map_get($breakpoints, lg)) {
      max-width: 1240px;
    }

    @media (map_get($breakpoints, xxl)) {
      max-width: 1600px;
    }

    @media (map_get($breakpoints, lg)) {
      padding-right: 2rem;
      padding-left: 2rem;
    }

    &.has-sidebar {
      @media (map_get($breakpoints, md)) {
        padding-left: 305px;
      }
    }
  }

  &.has-notification {
    padding-top: 105px;

    @media (map_get($breakpoints, sm)) {
      padding-top: 130px;
    }

    @media (map_get($breakpoints, md)) {
      padding-top: 80px;
    }
  }
}

.page-content {
  width: 100%;
  padding: 0;
  margin: 0 auto;

  @media (map_get($breakpoints, sm)) {
    padding-top: 0;
    max-width: 700px;
  }

  @media (map_get($breakpoints, md)) {
    max-width: 960px;
  }

  @media (map_get($breakpoints, lg)) {
    max-width: 1240px;
  }

  @media (map_get($breakpoints, xxl)) {
    max-width: 1600px;
  }

  //@media (map_get($breakpoints, md_alt)) {
  //  padding-top: 40px;
  //}

  &.has-sidebar {
    @media (map_get($breakpoints, md)) {
      padding-left: 285px;
    }
  }

  &.has-header {
    //padding-top: 0;
  }

  &.full-width {
    padding: 0;
    max-width: none;
  }
}

.page-notification {
  position: fixed;
  top: 54px;
  width: 100%;
  z-index: map_get($z-index, sidebar);

  @media (map_get($breakpoints, sm)) {
    top: 60px;
  }

  @media (map_get($breakpoints, lg)) {
    top: 68px;
  }
  @media (map_get($breakpoints, xxl)) {
    top: 88px;
  }
}
</style>
